/**
 * Scroll to URL hash target after cross-page navigation.
 * Native hash scrolling often fails when layout shifts (transitions, GSAP, images)
 * or when navigation is deferred (page fade-out).
 */

const HASH_RETRY_DELAYS_MS = [0, 100, 300, 600, 1000, 1500];

const getHashTarget = () => {
  const { hash } = window.location;
  if (!hash || hash.length < 2) {
    return null;
  }

  const id = decodeURIComponent(hash.slice(1));
  return document.getElementById(id);
};

export const scrollToHash = () => {
  const target = getHashTarget();
  if (!target) {
    return false;
  }

  const root = document.documentElement;
  const previousScrollBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = "smooth";

  target.scrollIntoView({ block: "start" });

  requestAnimationFrame(() => {
    root.style.scrollBehavior = previousScrollBehavior;
  });

  return true;
};

export const scheduleHashScrollAttempts = () => {
  HASH_RETRY_DELAYS_MS.forEach((delay) => {
    window.setTimeout(scrollToHash, delay);
  });
};

export const initHashScroll = () => {
  if (!window.location.hash) {
    return;
  }

  scheduleHashScrollAttempts();

  window.addEventListener(
    "load",
    () => {
      scheduleHashScrollAttempts();
    },
    { once: true },
  );

  window.addEventListener("pageshow", (event) => {
    if (!window.location.hash) {
      return;
    }
    scheduleHashScrollAttempts();
  });
};
